module.exports = __webpack_public_path__ + "static/img/18一种印花机色浆过滤装置.b3f616ce.jpg";